import { render, staticRenderFns } from "./CategoryPanelItem.vue?vue&type=template&id=52573bd1&scoped=true&"
import script from "./CategoryPanelItem.vue?vue&type=script&lang=js&"
export * from "./CategoryPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPanelItem.vue?vue&type=style&index=0&id=52573bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52573bd1",
  null
  
)

export default component.exports